import { invoicesOn } from './business-settings'
import { isCommercial, isMonthly, hintDismissed } from './commercial'
import { getMe } from './me'

// Looks like a business (Liam, 26 Oct 2026: "Invoices are still complicated is there a way to detect the address might
// be a business and then offer help"; design B, https://claude.ai/artifact/2idUxH4jyrEdpi8D15jAiM; Astra's check of the
// logic the same day). Joel's address line read "Peter Dyer Photographs Ltd", and nothing told Liam to switch Commercial
// on. Words only: an email address is a contact, not evidence of who pays (Astra 11).

// A company anywhere in the name or address.
const COMPANY = /(?:^|[^a-z])(ltd|limited|llp|plc|inc)\.?(?![a-z])|(?:^|\s)(&|and)\s+co\.?(?![a-z])/i
// A trade in the NAME only: the address has Church Road, School Lane, Studio flat. No word that is also a common
// surname (Church, Hall, Barber): "Mr Church" is a person (Astra 12).
const TRADE = /(?:^|[^a-z])(studios?|surgery|dental|dentist|clinic|practice|caf[eé]|restaurant|pub|hotel|salon|barbers|garage|motors|shop|store|offices?|school|nursery|centre|photography|photographs|lettings|estates|properties|management)(?![a-z])/i
// A business address: a unit, a business park or an estate.
const PLACE = /(?:^|[^a-z])(unit\s+[0-9a-z]{1,4}(?![a-z])|business\s+park|industrial\s+estate|trading\s+estate)/i

export interface HintCustomer {
  id: number
  name?: string | null
  address?: string | null
  commercial?: number | boolean | null
  invoice_mode?: string | null
  business_hint_dismissed?: number | boolean | null
}

// What makes it look like a business, in the words shown ("it says Ltd"), or null.
export function businessReason(c: { name?: string | null; address?: string | null }): string | null {
  const name = String(c.name ?? ''), address = String(c.address ?? '')
  const company = COMPANY.exec(name) ?? COMPANY.exec(address)
  if (company) return company[1] ? tidy(company[1]) : '& Co'
  const trade = TRADE.exec(name)
  if (trade) return tidy(trade[1])
  const place = PLACE.exec(address)
  if (place) return tidy(place[1])
  return null
}

function tidy(word: string): string {
  const w = word.replace(/\s+/g, ' ').trim()
  if (/^(ltd|llp|plc)$/i.test(w)) return w.toUpperCase() === 'LTD' ? 'Ltd' : w.toUpperCase()
  return w.split(' ').map((x) => x.charAt(0).toUpperCase() + x.slice(1).toLowerCase()).join(' ')
}

// Ask: the owner's phone, Invoices on, not already commercial (or invoiced once a month, which has its own flow: Astra 3),
// not answered "don't ask again", and the words say business. Changes still waiting for signal are laid over.
export function businessHint(c: HintCustomer | null | undefined): string | null {
  if (!c || getMe()?.role !== 'owner' || !invoicesOn()) return null
  if (isCommercial(c) || isMonthly(c) || hintDismissed(c)) return null
  return businessReason(c)
}
